import React, { useEffect } from 'react';
import {
  CardTheme,
  TextLarge,
  RenderForm,
  ButtonTheme,
  TimelineComponent,
} from '../../../components';
import { StyledContainer } from './styles';
import { useForm } from 'react-hook-form';
import { Row, Col, Modal, Spin } from 'antd';
import {
  FORM_CLAIM_DETAIL_PERSONAL,
  FORM_CLAIM_DETAIL_CLAIM,
  FORM_CLAIM_EDIT_DETAIL_PICTURE,
} from './forms';
import { ContainerButton } from '../../../styles/global-style';
import { navigateTo } from '@/utils/navigation/index.js';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { useMemo, useState } from 'preact/hooks';
import { useGetClaimDetail } from './hooks/useGetClaimDetail';
import { useModal } from '../../../components/modal/hooks/useModal';
import { ModalReject } from './modal/modalReject';
import { useApproveClaim } from './hooks/useApproveClaim';
import { canResendRequest, useResendRequest } from './hooks/useResendRequest';
import { ResendRequestModal } from './modal/ResendRequestModal';
import { canResendCs, useHasResendCsPrivilege, useResendCs } from './hooks/useResendCs';
import { ChangeProductModal } from './modal/changeProduct';
import { color } from '../../../resources';
import { useSelector } from 'react-redux';

export const ClaimDetail = () => {
  const { open: openChangeProduct, onToggle: onToggleChangeProduct } = useModal();
  const { control, setValue, getValues } = useForm();
  const [state, setState] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const claimCode = queryParams.get('code');
  const users = useSelector((state) => state.authen.users);
  const privilegeAbmType = useMemo(() => users?.privilegeAbmType, [users]);
  const hasResendCsPrivilege = useHasResendCsPrivilege();

  useEffect(() => {
    if (claimCode) {
      setState({ claimCode });
    }
  }, [claimCode]);

  const [claimData, setClaimData] = useState({});
  const [timelineList, setTimelineList] = useState([]);
  const { open: openReject, onToggle: onToggleReject } = useModal();
  const {
    dataSource,
    loading: isLoadingClaimDetail,
    onFetch: onFetchClaimDetail,
  } = useGetClaimDetail({
    claimCode: state?.claimCode,
    setValue,
  });
  const [modal, modalContext] = Modal.useModal();

  const { mutate: onSubmitApproveClaim, isPending: isPendingApproveClaim } = useApproveClaim({
    modal,
    onSuccessCallback: onFetchClaimDetail,
  });
  const resendRequest = useResendRequest({ onSuccess: onFetchClaimDetail });
  const { startResend, isPending: isPendingResendCs } = useResendCs({
    modal,
    onSuccess: onFetchClaimDetail,
  });

  useEffect(() => {
    const updateClaimData = () => {
      try {
        if (dataSource?.claim) {
          setClaimData(dataSource?.claim);

          setValue('claimCode', dataSource?.claim?.claimCode);
          setValue('claimId', dataSource?.claim?.claimId);
        }

        if (dataSource?.timelineList) {
          const timeline = dataSource?.timelineList.map((timeline) => {
            return {
              text: timeline?.optionStatusNameTh,
              color:
                timeline?.optionStatusCode == dataSource?.claim?.claimStatus ? 'green' : 'black',
            };
          });
          setTimelineList(timeline);
        }
      } catch (error) {}
    };

    updateClaimData();
  }, [dataSource, setValue]);

  const onModalReject = (record) => {
    setClaimData(record);
    onToggleReject({ record });
  };

  const onSubmitApprove = () => {
    if (claimData?.noDeductWarranty === 'Y') {
      modal.warning({
        title: 'เคลมไม่หักประกันต้องอนุมัติในเมนู อนุมัติ > ไม่ตัดประกัน',
        okText: 'ตกลง',
      });
      return;
    }
    const claimId = getValues('claimId');
    if (claimId) {
      onSubmitApproveClaim({ claimIdList: [claimId] });
    }
  };

  const goToNoDeductApproval = () => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_CLAIM_APPROVE.PATH });
  };

  const goBack = () => {
    navigateTo({
      pathname: ROUTES_PATH.ROUTE_CLAIM_PRODUCT.PATH,
      state: getValues(),
    });
  };

  useEffect(() => {
    if (dataSource?.claim?.remainingDays > 36000) {
      setValue('remainingDays', 'ตลอดชีวิต');
    }
    if (dataSource?.claim?.claimedDays) {
      setValue('claimedDays', dataSource?.claim?.claimedDays + '  วัน');
    }
  }, [dataSource]);

  return (
    <Spin spinning={isLoadingClaimDetail}>
      <StyledContainer>
        <TextLarge text="รายละเอียดรายการเคลมสินค้า" />
        <Row gutter={[24, 24]}>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="ข้อมูลส่วนตัว" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CLAIM_DETAIL_PERSONAL()}
              />
            </CardTheme>
          </Col>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="ข้อมูลการแจ้งเคลม" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CLAIM_DETAIL_CLAIM()}
              />
            </CardTheme>
          </Col>
          <Col span={4}>
            <TextLarge text="สถานะการเคลม" /> <br />
            <TimelineComponent timelineList={timelineList} />
          </Col>
        </Row>
        <br />
        <Row gutter={[24, 24]}>
          <Col span={10}>
            <CardTheme>
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CLAIM_EDIT_DETAIL_PICTURE()}
              />
            </CardTheme>
          </Col>
        </Row>
        <Row justify="space-between" align="middle" style={{ marginTop: '16px' }}>
          <Col>
            <ContainerButton>
              <ButtonTheme useFor="BACK" title="ย้อนกลับ" onClick={goBack} />
            </ContainerButton>
          </Col>
          {claimData?.claimStatus !== 'TRANSPORTED' && privilegeAbmType !== 'READ' && (
            <Col>
              <ContainerButton>
                {claimData?.noDeductWarranty === 'Y' &&
                claimData?.approveStatus === 'WAIT_APPROVE' &&
                claimData?.claimStatus === 'WAIT' ? (
                  <ButtonTheme
                    useFor="CONFIRM"
                    title="ไปเมนู อนุมัติ > ไม่ตัดประกัน"
                    onClick={goToNoDeductApproval}
                    style={{ marginRight: '8px' }}
                  />
                ) : isPendingApproveClaim ? (
                  <Spin spinning={isPendingApproveClaim}></Spin>
                ) : (
                  <ButtonTheme
                    useFor="CONFIRM"
                    title="อนุมัติ"
                    onClick={onSubmitApprove}
                    disabled={
                      claimData?.claimStatus !== 'WAIT' || claimData?.noDeductWarranty === 'Y'
                    }
                    style={{ marginRight: '8px' }}
                  />
                )}
                <ButtonTheme
                  useFor="REJECT"
                  title="ไม่อนุมัติ"
                  onClick={() => onModalReject(claimData)}
                  disabled={claimData?.processStatus === 'SHIPPED'}
                />
                {canResendRequest(claimData) && (
                  <ButtonTheme
                    useFor="CONFIRM"
                    title="ส่งซ้ำ"
                    disabled={resendRequest.isPending}
                    onClick={() => resendRequest.openRequest(claimData)}
                    style={{ marginLeft: '8px' }}
                  />
                )}
                {hasResendCsPrivilege &&
                  canResendCs(claimData) &&
                  (isPendingResendCs ? (
                    <Spin spinning={isPendingResendCs} style={{ marginLeft: '8px' }}></Spin>
                  ) : (
                    <ButtonTheme
                      useFor="CONFIRM"
                      title="ขอเลขเอกสาร CS"
                      onClick={() => startResend([claimData.claimId])}
                      style={{ marginLeft: '8px' }}
                    />
                  ))}
              </ContainerButton>
            </Col>
          )}
          {privilegeAbmType !== 'READ' && (
            <Col>
              <ContainerButton>
                <ButtonTheme
                  useFor="CHANGE"
                  title="เปลี่ยนสินค้า"
                  onClick={onToggleChangeProduct}
                  style={{ marginRight: '8px' }}
                />
                {openChangeProduct && (
                  <ChangeProductModal
                    open={openChangeProduct}
                    onToggle={onToggleChangeProduct}
                    initialValues={dataSource}
                  />
                )}
                {claimData?.claimStatus !== 'TRANSPORTED' && (
                  <ButtonTheme
                    useFor="EDIT2"
                    title="แก้ไข"
                    onClick={() => {
                      navigateTo({
                        pathname: ROUTES_PATH.ROUTE_CLAIM_EDIT_DETAIL.PATH,
                        state: getValues(),
                      });
                    }}
                  />
                )}
              </ContainerButton>
            </Col>
          )}
        </Row>
        {openReject && (
          <ModalReject open={openReject} onToggle={onToggleReject} initialValues={claimData} />
        )}
        {resendRequest.target && <ResendRequestModal request={resendRequest} />}
        {modalContext}
      </StyledContainer>
    </Spin>
  );
};
